import { RouteCodes } from '@strata/constants';
import { formatDate } from '@strata/helper-functions';
import { FormSectionWithMessage, FormSectionWithRows } from '@strata/react-form-section';
import { DetailLabelValuePair } from '@strata/react-label-value-pairs';
import { ServicingRate } from '@strata/react-servicing-rate';
import { FIcon } from '@strata/react-status-icons';

import { Permissions } from 'services/constants';
import { ReferralStatusMessageMap } from 'services/referralHelpers';
import { useAppSelector } from 'store';
import { type ReferralDetails } from 'store/api/treatmentApi';

interface LiveReferralDetailsProps {
    referralDetails?: ReferralDetails;
}

export const LiveReferralDetails = ({ referralDetails = undefined }: LiveReferralDetailsProps) => {
    /** Is/was the referral a Live Referral */
    const wentToLiveReferrals = referralDetails?.routeCode === RouteCodes.DEFAULT;
    const sectionTitle = wentToLiveReferrals ? 'Live Referral Details' : 'Assignment Details';
    const referralStatusMessage = referralDetails
        ? ReferralStatusMessageMap[referralDetails.referralStatus]
        : undefined;

    const { permissions } = useAppSelector((state) => state.auth);

    return referralStatusMessage ? (
        <FormSectionWithMessage
            sectionTitle={sectionTitle}
            icon={<FIcon />}
            primaryText={referralStatusMessage}
            secondaryText="No details to show."
        />
    ) : (
        <FormSectionWithRows
            sectionTitle={sectionTitle}
            isLoading={!referralDetails}
            rowOneContent={
                <>
                    <DetailLabelValuePair
                        style={{ width: '33%' }}
                        label={wentToLiveReferrals ? 'Ended At' : 'Assigned At'}
                        value={formatDate(referralDetails?.contractedDate)}
                    />
                    {permissions.includes(Permissions.READ_REFERRAL_RATES) && (
                        <DetailLabelValuePair
                            label="Referral Rate"
                            value={
                                <ServicingRate
                                    servicingRate={referralDetails?.winningBidRate}
                                    referentPriceType={referralDetails?.referentPriceType}
                                />
                            }
                        />
                    )}
                </>
            }
        />
    );
};
